import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";


export const fetchDeposits = async (user, page, limit, status, startDate, endDate) => {

  try {
    const params = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}&status=${status}`
    const { data } = await axios.get(`${API_BASE_URL}/agbk/deposits/external/list${params}`,
      buildHeaders(user))
    return data?.data?.external_deposits

  } catch (err) {
    console.log(err)
    return {
      error: err
    }
  }

}

export const linkToClient = async (user, deposit_id, user_uuid) => {

  try {
    const { data } = await axios.post(`${API_BASE_URL}/agbk/deposits/external/link`, {
      deposit_id,
      user_uuid
    }, buildHeaders(user))

    return data?.data

  } catch (err) {
    console.log(err)
    throw err
  }
}

export const fetchDepositUsers = async (user, query) => {

  try {
    const params = `?search=${query}`
    const { data } = await axios.get(`${API_BASE_URL}/agbk/users/search${params}`, buildHeaders(user))
    return data?.data
  } catch (err) {
    console.log(err)
    throw err
  }
}